import React from 'react';
import { Box } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import './ARSAccordian.css';

function ARSAccordian({ children, className }) {
  return <Box className={`ARSAccordian ${className}`}>{children}</Box>;
}

ARSAccordian.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ARSAccordian.defaultProps = {
  className: null,
};

export default ARSAccordian;
